//src/utils/number.js
export const formatNumber = (value) => {
  return new Intl.NumberFormat("id-ID").format(Number(value || 0));
};

export const safeNumber = (value) => {
  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : 0;
};
